var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.57,
    height: 16.051,
    viewBox: "0 0 16.57 16.051",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_back",
    "data-name": "icona back",
    transform: "translate(-529.717 -124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icona_back-2",
    "data-name": "icona back",
    d: "M15.761,16.642l-.409-.686C12.213,10.68,7.916,11,6.864,11.174v4.157L0,8.456,6.864,1.644V5.737h.1c3.815,0,5.575,1.6,5.651,1.675a9.355,9.355,0,0,1,3.294,8.446ZM7.773,10.51a9.1,9.1,0,0,1,7.617,4.372,8.725,8.725,0,0,0-3.172-7.013c-.03-.027-1.809-1.635-5.648-1.516l-.314.009V3.108L.863,8.457l5.392,5.4V10.685l.232-.057A6.067,6.067,0,0,1,7.773,10.51Z",
    transform: "translate(530 122.856)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1833",
    "data-name": "Rettangolo 1833",
    width: 16,
    height: 16,
    transform: "translate(530 124)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.3549364c8e9ef13c689afb5a0bbb7d23.svg";
export { ForwardRef as ReactComponent };